import { render } from "./ModuleListComponent.vue?vue&type=template&id=2ff66172&scoped=true"
import script from "./ModuleListComponent.vue?vue&type=script&lang=js"
export * from "./ModuleListComponent.vue?vue&type=script&lang=js"

import "./ModuleListComponent.vue?vue&type=style&index=0&id=2ff66172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff66172"]])

export default __exports__